export default "__VITE_ASSET__DZanB9Z___"